import { useTheme } from '@mui/material/styles'
import * as React from 'react'

import Radio from '@mui/material/Radio'
import FormControl from '@mui/material/FormControl'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'

import { useData } from './useData'
import { getStyles } from './styling'
import { useHandlers } from './useHandlers'
import { useReferralsContext } from '@user/components/Referrals/context'
import { ReferralFormProps } from '@user/components/Referrals/components/UpdateReferral/UpdateReferralForm/UpdateReferralForm'

export function ReferralTypeSelect(props: ReferralFormProps) {
  const [{ referralType }] = useReferralsContext()

  const { options } = useData()
  const { onChange } = useHandlers(props)

  const theme = useTheme()
  const styles = getStyles(theme)
  return (
    <FormControl component="fieldset">
      <RadioGroup
        name="referralSource"
        onChange={onChange}
        value={String(referralType || '')}
      >
        {options.map((option, index) => (
          <FormControlLabel
            sx={styles.label}
            key={index}
            value={option.value}
            data-test-id={`referral-type-${option.value}-radio-button`}
            control={
              <Radio
                sx={{
                  padding: `${theme.spacing(0.4)} ${theme.spacing(
                    0.4,
                  )} ${theme.spacing(0.4)} 0`,
                }}
              />
            }
            label={option.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  )
}
